import { action, createRequestTypes } from '../base';

export const tdsTcsActionTypes = {
  CREATE_TDS_TCS: createRequestTypes('CREATE_TDS_TCS'),
  GET_TDS_TCS: createRequestTypes('GET_TDS_TCS'),
  GET_DEFAULT_TDS_TCS: createRequestTypes('GET_DEFAULT_TDS_TCS'),
  UPDATE_TDS_TCS: createRequestTypes('UPDATE_TDS_TCS'),
  DELETE_TDS_TCS: createRequestTypes('DELETE_TDS_TCS'),
};

/**
 *
 */
class TdsTcsActions {
  /**
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  createTdsTcs = (payload, callback) => action(tdsTcsActionTypes.CREATE_TDS_TCS.REQUEST, {
    payload,
    callback,
  })

  /**
   *
   * @param createTdsTcsLoading
   * @return {{type: *}}
   */
  createTdsTcsLoading = (createTdsTcsLoading) => action(tdsTcsActionTypes.CREATE_TDS_TCS.LOADING, {
    createTdsTcsLoading,
  })

  /**
   * @return {{type: *}}
   */
  getTdsTcs = (page, limit) => action(tdsTcsActionTypes.GET_TDS_TCS.REQUEST, { page, limit })

  /**
   *
   * @param getTdsTcsLoading
   * @return {{type: *}}
   */
   getTdsTcsLoading = (getTdsTcsLoading) => action(tdsTcsActionTypes.GET_TDS_TCS.LOADING, {
     getTdsTcsLoading,
   })

  /**
   * @param tdsTcses
   * @return {{type: *}}
   */
  getTdsTcsSuccess = (tdsTcs) => action(tdsTcsActionTypes.GET_TDS_TCS.SUCCESS, {
    tdsTcs,
  })

  /**
   * @param tdsTcsName
   * @return {{type: *}}
   */
  getDefaultTdsTcs = (tdsTcsName) => action(tdsTcsActionTypes.GET_DEFAULT_TDS_TCS.REQUEST, {
    tdsTcsName,
  })

  /**
   *
   * @param getDefaultTdsTcsLoading
   * @return {{type: *}}
   */
   getDefaultTdsTcsLoading = (getDefaultTdsTcsLoading) => action(tdsTcsActionTypes.GET_DEFAULT_TDS_TCS.LOADING, {
     getDefaultTdsTcsLoading,
   })

  /**
   * @param tdsTcses
   * @return {{type: *}}
   */
  getDefaultTdsTcsSuccess = (defaultTdsTcs) => action(tdsTcsActionTypes.GET_DEFAULT_TDS_TCS.SUCCESS, {
    defaultTdsTcs,
  })

  /**
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  updateTdsTcs = (payload, callback) => action(tdsTcsActionTypes.UPDATE_TDS_TCS.REQUEST, {
    payload,
    callback,
  })

  /**
   *
   * @param updateTdsTcsLoading
   * @return {{type: *}}
   */
  updateTdsTcsLoading = (updateTdsTcsLoading) => action(tdsTcsActionTypes.UPDATE_TDS_TCS.LOADING, {
    updateTdsTcsLoading,
  })

  /**
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  deleteTdsTcs = (payload, callback) => action(tdsTcsActionTypes.DELETE_TDS_TCS.REQUEST, {
    payload,
    callback,
  })

  /**
   *
   * @param deleteTdsTcsLoading
   * @return {{type: *}}
   */
  deleteTdsTcsLoading = (deleteTdsTcsLoading) => action(tdsTcsActionTypes.DELETE_TDS_TCS.LOADING, {
    deleteTdsTcsLoading,
  })
}

export default new TdsTcsActions();
